// Used in the ChatBubbles blade component
function chatBubblesComponent() {
    return {
        chatBubblePages: [],
        currentPage: 0,
        chatBubbleTransitions: [],

        init() {
            this.chatBubblePages = this.$root.querySelectorAll('.chatbubble-page');
            this.showPage(this.currentPage);
        },

        clearChatBubbleTransitions() {
            this.chatBubbleTransitions.forEach(timeout => clearTimeout(timeout));
            this.chatBubbleTransitions = [];
        },

        showPage(page) {
            this.clearChatBubbleTransitions();

            this.chatBubblePages.forEach((pageElement, index) => {
                pageElement.style.display = 'none';
            });

            const currentPageElement = this.chatBubblePages[page];
            if (currentPageElement) {
                currentPageElement.style.display = 'block';
                const bubbleContainers = currentPageElement.querySelectorAll('.chatbubble-container');
                bubbleContainers.forEach((container, index) => {
                    const timeout = setTimeout(() => {
                        container.classList.add('visible');
                        container.classList.remove('opacity-0', 'scale-50');
                    }, index * 500);
                    this.chatBubbleTransitions.push(timeout);
                });
            }

            this.updateButtonVisibility();
            this.updateActivePageIndicator();
        },

        hidePage(page) {
            const currentPageElement = this.chatBubblePages[page];
            if (currentPageElement) {
                const bubbleContainers = currentPageElement.querySelectorAll('.chatbubble-container');
                bubbleContainers.forEach((container, index) => {
                    container.classList.remove('visible');
                    container.classList.add('opacity-0', 'scale-50');
                });
            }
        },

        updateButtonVisibility() {
            const dialogueButtonContainer = this.$root.querySelector('#dialogueButtonContainer');
            const prevButton = this.$root.querySelector('#prevButton');
            const nextButton = this.$root.querySelector('#nextButton');

            if (this.chatBubblePages.length <= 1) {
                dialogueButtonContainer.style.display = 'none';
                return;
            } else {
                dialogueButtonContainer.style.display = 'flex';
            }

            const showPrev = this.currentPage > 0;
            const showNext = this.currentPage < this.chatBubblePages.length - 1;

            if (showPrev) {
                prevButton.classList.remove('btn-disabled');
            } else {
                prevButton.classList.add('btn-disabled');
            }

            if (showNext) {
                nextButton.classList.remove('btn-disabled');
            } else {
                nextButton.classList.add('btn-disabled');
            }
        },

        updateActivePageIndicator() {
            const dots = this.$root.querySelectorAll('.dot');

            dots.forEach(dot => {
                dot.classList.remove('bg-primary');
                dot.classList.add('bg-base-300');
            });
            const activeDot = this.$root.querySelector(`.dot[data-page="${this.currentPage}"]`);
            if (activeDot) {
                activeDot.classList.remove('bg-base-300');
                activeDot.classList.add('bg-primary');
            }
        },

        nextPage() {
            if ((this.currentPage + 1) < this.chatBubblePages.length) {
                this.hidePage(this.currentPage);
                this.currentPage++;
                this.showPage(this.currentPage);
            }
        },

        prevPage() {
            if (this.currentPage > 0) {
                this.hidePage(this.currentPage);
                this.currentPage--;
                this.showPage(this.currentPage);
            }
        }
    };
}


window.ChatBubblesComponent = chatBubblesComponent;
